import { Injectable, signal } from '@angular/core';
import { EduContentInterface, LearnosityItemsConfigInterface } from '@campus/dal';
import { Subject } from 'rxjs';
import { LearnosityDialogComponentType } from '../interfaces';

export interface LearnosityOverlayData {
  config: LearnosityItemsConfigInterface;
  component: LearnosityDialogComponentType;
  eduContent?: EduContentInterface;
}

@Injectable({ providedIn: 'root' })
export class LearnosityOverlayService {
  readonly isOpen = signal(false);
  readonly data = signal<LearnosityOverlayData | null>(null);

  private readonly _closed$ = new Subject<void>();
  readonly closed$ = this._closed$.asObservable();

  open(overlayData: LearnosityOverlayData): void {
    this.data.set(overlayData);
    this.isOpen.set(true);
  }

  close(): void {
    this.isOpen.set(false);
    this.data.set(null);
    this._closed$.next();
  }
}
